import Icon from 'components/_UI/Icon';
import Text from 'components/_UI/Text';
import React from 'react';
import styled, { css } from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import sizes from 'theme/sizes';
import Background from './Background';
import PropTypes from 'prop-types';
import Button from 'components/_UI/Button';
import SignInHero from './SignInHero';
import SignInPanelDecor from './SignInPanelDecor';
import PartnerHero from './PartnerHero';

const copy = {
    title: ['Encontre eventos e coisas novas,', 'em qualquer lugar da sua região.'],
    subtitle: 'Crie agora sua conta e descubra tudo novo com Whizr.',
};

function PresentationBackground({ ComponentToRender, is }) {
    const isPartner = is === 'createPartner';
    // O cadastro é a continuação do login: mesma foto, hero e painel claro.
    const isSignIn = is === 'signIn' || is === 'signUp';

    return (
        <Container $dmSans={isSignIn || isPartner}>
            <Background variant={isSignIn ? 'signIn' : is} />

            <LogoContainer $signIn={isSignIn} $partner={isPartner}>
                <Icon name='whizr-inline-logo' color='white' />
            </LogoContainer>

            {isSignIn ? (
                <SignInHero />
            ) : isPartner ? (
                <PartnerHero />
            ) : (
                <TextContainer>
                    <Text name='hero' color={colors.neutralLight}>
                        {copy.title[0]}
                    </Text>
                    <Text name='hero' color={colors.neutralLight} marginTop='-15px'>
                        {copy.title[1]}
                    </Text>
                    <Text name='subtitle' color={colors.neutralLight} marginTop='5px'>
                        {copy.subtitle}
                    </Text>
                </TextContainer>
            )}

            {isSignIn && <SignInPanelDecor />}

            <SignContainer
                $signIn={isSignIn}
                $partner={isPartner}
                recoverAccount={is === 'recoverAccount' && colors.blueVerticalGradient}
            >
                <ComponentToRender />
            </SignContainer>
        </Container>

    )
};

PresentationBackground.propTypes = {
    is: PropTypes.oneOf(['signIn', 'signUp', 'recoverAccount', 'createPartner'])
};

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;

    ${({ $dmSans }) => $dmSans && css`
        font-family: 'DM Sans', 'Roboto', sans-serif;

        & input, & button, & textarea {
            font-family: inherit;
        }
    `};
`;

const TextContainer = styled.div`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
        padding-top: 20%;
        padding-left: 4%;
        width: 50%;
    };

    @media screen and (min-width: ${breakpoints.xl}) {
        display: block;
        height: 100vh;
        padding: 17% 4%;
    };
`;

const LogoContainer = styled.div`
    display: none;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
        position: absolute;
        top: 0;
        left: 4%;
        width: 200px;

        ${({ $signIn }) => $signIn && css`
            top: 75px;
            left: 72px;
            width: 254px;
            height: 70.5px;
        `};

        ${({ $partner }) => $partner && css`
            top: 62px;
            left: 67px;
            width: 243px;
            height: 67.5px;
        `};
    };
`;

const SignContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    
    ${({ $signIn }) => $signIn && css`
        overflow-y: auto;
        overflow-x: hidden;
        background:
            radial-gradient(circle 84px at calc(100% + 25px) 45px, #B9ACF7 0%, #B4A7F6 96%, rgba(180, 167, 246, 0) 100%),
            radial-gradient(circle 110px at calc(100% - 55px) -25px, #ECE8FD 0%, #DCD4FA 96%, rgba(220, 212, 250, 0) 100%),
            radial-gradient(circle 178px at calc(100% + 90px) calc(100% + 42px), #D8C9FE 0%, #CEBCFB 97%, rgba(206, 188, 251, 0) 100%),
            linear-gradient(180deg, #F8F6FD 0%, #F4F2FD 45%, #ECEBFD 100%);
    `};

    ${({ $partner }) => $partner && css`
        background: #F8F7FE;
    `};

    ${({ recoverAccount }) => recoverAccount && css`
        background-image: ${recoverAccount};
    `};
    
    @media screen and (min-width: ${breakpoints.lg}) { 
        position: absolute;
        right: 0;
        top: 0;
        width: 33.5%;
        border-radius: ${sizes.grand} ${sizes.none} ${sizes.none} ${sizes.grand};

        ${({ $signIn }) => $signIn && css`
            width: 34.5625%;
            min-width: 460px;
            border-radius: 60px 0 0 60px;
            background: transparent;
            box-shadow: -10px 0 40px rgba(21, 17, 54, .18);
        `};

        ${({ $partner }) => $partner && css`
            width: 36.9375%;
            min-width: 500px;
            border-radius: 40px 0 0 40px;
            overflow: hidden;
            background: linear-gradient(180deg, #F8F7FF 0%, #F6F6FE 55%, #F9F8FE 100%);
            box-shadow: -10px 0 40px rgba(10, 6, 40, .28);
        `};
    }
`;

export default PresentationBackground;
